module.exports = __webpack_public_path__ + "static/media/cordero-fresco.77369f4e.jpg";